export default __webpack_public_path__ + "static/media/45-deg.7b1831f5.svg";